import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

export type NavigateWithSearchProps = {
  to: string
}

export const NavigateWithSearch = ({ to }: NavigateWithSearchProps) => {
  const { search } = useLocation()

  return <Navigate to={{ pathname: to, search }} replace />
}
